/* services */
import { rei } from "@/services/api"

/* libraries */
import moment from 'moment'

class PessoasService {
  static storePessoa (params) {
    return rei.post(`pessoa`, { ...params }).then(res => res.data)
  }

  static getPessoaById (idPessoa) {
    return rei.get(`pessoa/${idPessoa}`).then(res => res.data)
  }

  static getCadastroByCPF (cpf) {
    loader({active: true})

    return rei.get(`pessoa?cpf=${cpf}`).then(res => {
      loader({active: false})
      return res.data
    })
  }

  static getPessoaByCPF (cpf) {
    return rei.get(`buscar-cpf/${cpf}`).then(({data}) => {
      return data.length && data[0]._source || { isEmpty: true }
    })
  }

  static getCpfFalecido (cpf, dataRegistro) {
    dataRegistro = moment(dataRegistro, 'YYYY-MM-DD').format('MM/DD/YYYY')

    return rei.get(`busca-cpf-falecido/${cpf.replace(/\.|-|_/g, '')}?data_registro=${dataRegistro}`).then(res => res.data)
  }

  static updatePessoa (idPessoa, params) {
    return rei.put(`pessoa/${idPessoa}`, { ...params }).then(res => res.data)
  }

  static storeGenitor (pessoaId, genitorId) {
    return rei.post(`genitores`, { pessoa_id: pessoaId, genitor_pessoa_id: genitorId }).then(res => res.data)
  }

  static storeGenitorPessoa (pessoaId, genitorId) {
    return rei.post(`genitor-pessoa`, { pessoa_id: pessoaId, genitor_pessoa_id: genitorId }).then(res => res.data)
  }

  static deletePessoa (idPessoa) {
    return rei.delete(`pessoa/${idPessoa}`).then(res => res.data)
  }
}

export default PessoasService
